
import atoms from "../../../../atoms";
import { ModalSearchProps, ProductDataByModelProps } from "../interface";
import "./modelSerach.scss";

const { Input, Image } = atoms;

const ModalSearch = ({
    errors,
    productData,
    handleSearchByModel,
    productDataByModel,
    handleModelSelect,
    previewTab,
    isEdit
}: ModalSearchProps) => {

    return (
        <>
            <Input
                errors={errors.modal_number}
                label={"Model Number"}
                type={"text"}
                placeholder={"Enter Model Number"}
                value={productData.modal_number}
                disabled={!productData?.product_type_id || isEdit}
                onChange={(e: any) => {handleSearchByModel(e?.target?.value?.trim());}}
            />
            { productData?.modal_number?.length > 0 && previewTab && (
                <ul className="list-group dropdown-list product-model-search-felid">
                    {productDataByModel?.map(
                        (item: ProductDataByModelProps, index: number) => (
                            <li
                                key={index}
                                className="list-group-item d-flex align-item-center product-model-search-list"
                                onClick={() => {
                                    handleModelSelect(item);
                                }}
                            >
                                <div className="fs-16 cursor-pointer">
                                    <div className="mx-3" style={{ width: "50px" }}>
                                        <Image
                                            src={item?.images[0]}
                                            className="w-100 rounded object-contain searchClass"
                                        />
                                    </div>
                                </div>
                                <div className="fs-16 cursor-pointer px-3">
                                        <div className="d-flex mt-2">
                                            {/* <h3 className="fs-12 fw-600 secondary-color ">
                                                Model No :{" "}
                                            </h3> */}
                                            <h3
                                                className="fs-12 fw-600 secondary-color"
                                                style={{ marginLeft: "10px" }}
                                            >
                                                {item?.modal_number} _ {item?.brand_color_code} _ {item?.glass_size}
                                            </h3>
                                        </div>
                                        <div className="d-flex">
                                            {/* <h3 className="fs-12 fw-600 secondary-color">
                                                Color Code :{" "}
                                            </h3> */}
                                            {/* <h3
                                                className=" fs-12 fw-600 secondary-color"
                                                style={{ marginLeft: "10px" }}
                                            >
                                                {item?.brand_color_code}
                                            </h3> */}
                                        </div>
                                </div>
                            </li>
                        )
                    )}
                </ul>
            )}
        </>
    );
};

export default ModalSearch;
